import * as Common from '@/tenant/common';

export class TransactionSummaryReportQuery extends Common.Query {
    constructor(){
        super("TransactionSummaryReportQuery", null);
    }
    public templateId:number=0;
    public projectItem: Common.ProjectItem = null;
    public segment: Common.Segment = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public sort: number = 0;
    public itemCategory: number = 0;
    public summaryCategory1: number = 0;
    public summaryCategory2: number = 0;
    public startDate: Date = null;
    public endDate: Date = null;
    public includeProspect: boolean = false;
    public onExcelExport:boolean = false;           
}

export class TransactionSummaryReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='TransactionSummaryReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}